import React from 'react';
import { Skeleton } from 'antd';

export default function CategoriesSkeleton() {
  const skeletonItems = Array.from({ length: 10 });

  return (
    <div className=" rounded-lg border space-y-2">
      {skeletonItems.map((_, index) => (
        <div
          key={index}
          className="flex justify-between items-center py-4 px-6 bg-white"
        >
          {/* Skeleton Title */}
          <Skeleton.Input active size="small" className="!w-48 !h-4" />

          {/* Skeleton Action Button */}
          <Skeleton.Node active className="!w-6 !h-6" />
        </div>
      ))}
    </div>
  );
}
